import { Typography, Button, Container } from "@mui/material";
import Box from "@mui/material/Box";
import { useNavigate } from "react-router-dom";
import { connect } from "react-redux";
import {useEffect, useState} from "react";

import {
  getResumoSolicAberta
} from "../../store/actions/CRTActions";
import Loading from "../loading";




const Welcome = ({ auth }) => {
    const navigate = useNavigate();

    const [dados, setDados] = useState(null);
    const [loading, setLoading] = useState(true);

    async function buscarSolicitacao() {
      setLoading(true);
        const resStatus = await getResumoSolicAberta(auth.idusuario);
        setDados(resStatus);
        setLoading(false);
    }

    useEffect(() => {
      const carregarSolicitacao = async () => {
        if (auth.tipoUsuario !== 'profissional') {
          await buscarSolicitacao();
        }

        setLoading(false);
      };

      carregarSolicitacao();
    }, [auth.idusuario]);


  return (
    <>
      {loading && (<Loading status={loading}/>)}
      <Box
        component="main"
        sx={{ maxHeight: "725px", overflow: "auto", width: "100%" }}
      >
        <Container>
          <Box pt={5} >
            { /* <News /> :) */ }
            <Typography variant="h6" align="center" marginBottom={2}>
              Bem-Vindo(a)!
            </Typography>
            
            <Typography variant="body" align="center" marginX={20} marginBottom={2} paragraph>O Sistema e-CRF é uma plataforma digital 
              desenvolvida para agilizar a emissão de Certidão de Regularidade (CR), visando a celeridade nos serviços e processos 
              da autarquia, tanto para os farmacêuticos quanto para as empresas</Typography>

            <Typography variant="body" align="center" paragraph>
              Utilize o menu para ir à tabela de solicitações ou clique {" "}
              {auth.tipoUsuario === 'empresa' ? 'em uma das opções abaixo' : 'na opção abaixo'}
            </Typography>
          </Box>
          <Box sx={{ display: "flex", gap: 2, justifyContent: "center" }}>
            {auth.tipoUsuario === 'empresa' &&
              <Button 
                variant="outlined"
                color="primary" 
                onClick={() => navigate("/empSolic")}
              >
                Cadastrar Solicitação
              </Button>
            }
            <Button 
              variant="outlined"
              color="primary" 
              onClick={() => navigate("/histSolic")}
            >
              Histórico de Solicitações
            </Button>
          </Box>
          {dados?.solicitacao_num && (
                <Box
                    sx={{
                        maxWidth: 700,
                        mx: 'auto',
                        mt: 3,
                        p: 3,
                        border: '1px solid #009999',
                        borderRadius: 2,
                        backgroundColor: '#f5ffff'
                    }}
                >
                    <Typography
                        variant="h6"
                        align="center"
                        sx={{
                            color: '#007777',
                            fontWeight: 'bold',
                            mb: 2
                        }}
                    >
                        Solicitação em andamento
                    </Typography>

                    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
                        <Typography>
                            <strong>Nº da solicitação:</strong> {dados.solicitacao_num}
                        </Typography>

                        <Typography>
                            <strong>Status atual:</strong> {dados.desc_status}
                        </Typography>

                        <Typography>
                            <strong>Tempo em aberto:</strong> {dados.dias_em_aberto} dias
                        </Typography>

                        <Typography>
                            <strong>Prazo restante:</strong> {dados.dias_para_expirar} dias
                        </Typography>

                        <Typography>
                                <strong>Pagamento:</strong>{' '}
                                {dados.boleto_pago
                                    ? `Identificado em ${new Date(dados.boleto_pago.replace(' ', 'T')).toLocaleString('pt-BR')}`
                                    : 'Sem Registro'}
                        </Typography>

                        <Typography>
                            <strong>Empresa:</strong> {dados.idEmpresa}
                        </Typography>
                    </Box>
                </Box>
            )}
              <Typography 
                variant="body" 
                align="center" 
                marginX={20} 
                marginBottom={2} 
                paragraph
                style={{
                  backgroundColor: '#FFFF99', /* amarelo fraco */
                  color: '#FF0000', /* vermelho */
                  marginTop: '30px',
                  padding: '8px 12px', /* para dar um respiro interno */
                  borderRadius: '4px' /* opcional - suaviza as bordas */
                }}
              >
                <strong>IMPORTANTE:</strong> Caso conste, na relação de profissionais, algum farmacêutico que não exerça mais a 
                função de <strong>RT</strong> ou <strong>AT</strong> na empresa, deverá ser solicitada previamente a respectiva 
                <strong> baixa de RT/AT</strong> no Acesso Restrito da empresa, em: 
                <strong> Serviços Online &gt; Baixa de RT/AT</strong>.
              </Typography>

        </Container>
      </Box>
    </>
  );
};
const mapStateToProps = (state) => ({
  auth: state.AutenticacaoReducer.autenticacao,
});
export default connect(mapStateToProps)(Welcome);
